import { Maybe } from '@/generated/codegen';

export const nullishToEmptyStr = <T extends object>(obj: T): T => {
  const replacer = (key: string, value: any) =>
    String(value) === 'null' || String(value) === 'undefined' ? '' : value;

  return JSON.parse(JSON.stringify(obj, replacer));
};

const replaceEmptyStrInObject =
  (newValue: any) =>
  <T extends object>(obj: T): T => {
    const replacer = (key: string, value: any) =>
      value === '' ? newValue : value;

    return JSON.parse(JSON.stringify(obj, replacer));
  };

export const emptyStrToNull = replaceEmptyStrInObject(null);

export const emptyStrToUndefined = replaceEmptyStrInObject(undefined);

export const isNotNull = <T>(item: Maybe<T>): item is T => item !== null;
export const isNotNullish = <T>(item: T): item is NonNullable<T> =>
  item !== null && item !== undefined;
